(function() {
  'use strict';

  const initForm = (form) => {
    const businessTypeSelect = form.querySelector('select[name="businessType"]');
    const seatingRow = form.querySelector('[id*="seatingCapacityRow"]');
    const spaceSizeRow = form.querySelector('[id*="spaceSizeRow"]');
    const roomsRow = form.querySelector('[id*="roomsCountRow"]');
    const seatingSelect = form.querySelector('select[name="seatingCapacity"]');
    const spaceSizeSelect = form.querySelector('select[name="spaceSize"]');
    const roomsSelect = form.querySelector('select[name="roomsCount"]');

    const hideAllConditional = () => {
      [seatingRow, spaceSizeRow, roomsRow].forEach(el => { if (el) el.style.display = 'none'; });
      if (seatingSelect) seatingSelect.value = '';
      if (spaceSizeSelect) spaceSizeSelect.value = '';
      if (roomsSelect) roomsSelect.value = '';
    };

    const showConditionalRows = (type) => {
      hideAllConditional();
      if (type === 'Restaurant' || type === 'Café') {
        if (seatingRow) seatingRow.style.display = 'flex';
      } else if (type === 'Retail') {
        if (spaceSizeRow) spaceSizeRow.style.display = 'flex';
      } else if (type === 'Hotel') {
        if (roomsRow) roomsRow.style.display = 'flex';
      }
    };

    if (businessTypeSelect) {
      businessTypeSelect.addEventListener('change', () => {
        showConditionalRows(businessTypeSelect.value);
      });
      showConditionalRows(businessTypeSelect.value);
    }

    form.addEventListener('reset', () => {
      hideAllConditional();
      if (businessTypeSelect) showConditionalRows(businessTypeSelect.value || 'Restaurant');
    });
  };

  const init = () => {
    document.querySelectorAll('[data-form-type="directions-workwith"]').forEach(form => {
      if (!form.dataset.chipsInitialized) {
        form.dataset.chipsInitialized = 'true';
        initForm(form);
      }
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    init();
    requestAnimationFrame(init);
  });

  document.addEventListener('shopify:section:load', init);
})();
